import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledEventDetailsDiv = styled.div`
  ${rtl`
  .eventDetails{
    @media ${theme.mediaQuery.tabletMax} {
      justify-content: center;

      .rfpPrepared,
      .rfpFile {
        margin-top: ${toRem(-16)};
      }

      .meetingType,
      .additionalServices,
      .vips {
        margin-top: ${toRem(-24)};
      }

    }
  }
  .textAreaInput {
    height: ${toRem(200)};
  }
  .rfpFile{
    border-radius: 0;
    &-btn {
      min-width: 170px;
      @media ${theme.mediaQuery.mobileOnly} {
        min-width: 132px;
      }
    }
  }

  .file-name {
    word-wrap: break-word;
  }

`}
`;
